import { CPIModalPlugin } from './../store/global/plugins/cpi-modal-plugin';
import type { Ref } from 'vue';
import { ref } from 'vue';
import { StudentAuthenticationService } from '../domain/services/student-authentication-service';
import { CaptchaService } from '../domain/services/captcha-service';
import Tracking from './tracking/tracking';
import mitt from 'mitt';
import { ISessionService } from '@studyportals/student-interfaces';
import { IEventAggregationService } from '@studyportals/event-aggregation-service-interface';

const authenticationServiceTracking = new Tracking();
const studentAuthenticationService: StudentAuthenticationService = {} as StudentAuthenticationService;
const captchaService = new CaptchaService();
const globalStoreCaptcha = captchaService.createInstance();
const sessionService: ISessionService = {} as ISessionService;
const eventBus = mitt();
const eventAggregationService: IEventAggregationService | undefined = window['EventAggregationService'] as IEventAggregationService | undefined;

const cpiModalPlugin = new CPIModalPlugin(eventAggregationService);


export default {
	authenticationServiceTracking,
	studentAuthenticationService,
	captchaService,
	globalStoreCaptcha,
	sessionService,
	eventBus,
	eventAggregationService,
	cpiModalPlugin,
	isLoggedIn: ref(null) as Ref<boolean | null>,
};
